import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-retirement-healthcare-costs',
  templateUrl: './pre-retirement-healthcare-costs.component.html',
  styleUrls: ['./pre-retirement-healthcare-costs.component.scss']
})
export class PreRetirementHealthcareCostsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PreRetirementHealthcareCostsComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
